module.exports = __webpack_public_path__ + "media/images/pic/teachers/weronika-smorag-6913c1f94b84476e2774d7416dec5a85.webp";